export function loadUser() {
    const userString = localStorage.getItem('user');
    return JSON.parse(userString);
}

export function storeUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
}